import { Injectable } from '@angular/core';
import { HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { IMailTransporterConfiguration } from '../models/mail-transporter.configuration';
import { API_ENDPOINTS } from '../models/enums/endpoints.enum';
import { ApiProviderService } from './api-provider.service';

@Injectable({ providedIn: 'root' })
export class MailTransporterConfigurationService {
  public publicResourceUrl = API_ENDPOINTS.TRANSPORTER_CONFIGURATION;
  public moderatorResourceUrl = API_ENDPOINTS.MODERATOR_TRANSPORTER_CONFIGURATION;

  constructor(protected apiProvider: ApiProviderService) {}

  retrieveConfiguration(transporterId?: number): Observable<HttpResponse<IMailTransporterConfiguration>> {
    return this.apiProvider.publicGet<IMailTransporterConfiguration>(this.publicResourceUrl('mails', transporterId), { observe: 'response' });
  }

  updateConfiguration(configuration: IMailTransporterConfiguration, transporterId?: number): Observable<HttpResponse<IMailTransporterConfiguration>> {
    return this.apiProvider.put<IMailTransporterConfiguration>(this.moderatorResourceUrl('mails', transporterId), configuration);
  }
}
